/**
 * From crkfx6/js/k_utility.js
 * implement by Supawet.A
 */
function format(num,dec,thousand,pnt,curr1,curr2,n1,n2) {
	if(num == undefined) return num; // 2-Apr-2015
	
	if(dec == undefined) dec = 2;
	if(thousand == undefined) thousand = ',';
	if(pnt == undefined) pnt = '.';
	if(curr1 == undefined) curr1 = '';
	if(curr2 == undefined) curr2 = '';
	if(n1 == undefined) n1 = '';
	if(n2 == undefined) n2 = '';
	
	if(num.replace != undefined) num = num.replace(/,/g , ''); // 14-Mar-2015
	if(num < 0) {
		var x = Math.round(Math.abs(num) * Math.pow(10,dec)) * -1;
	} else {
  	var x = Math.round(num * Math.pow(10,dec));
	}
	
	if (x >= 0) n1=n2='';
	
	var y = (''+Math.abs(x)).split('');var z = y.length - dec; 
	
	if (z<0) z--; for(var i = z; i < 0; i++) y.unshift('0'); 
	if (z<0) z = 1; y.splice(z, 0, pnt); 
	if(y[0] == pnt) y.unshift('0'); 
	
	while (z > 3) {
		z-=3; 
		y.splice(z,0,thousand);
	}
	var r = curr1+n1+y.join('')+n2+curr2;

	if(dec == 0) r = r.replace(/\.$/, ''); // Added by Koon - 27-Nov-2013

	return (parseFloat(num) < 0 ? '-' : '') + r;
}

function valueOf(input) {
	if(typeof input == 'string') {
		var num = input.replace(/,/g, '');
		return parseFloat(num)
	} else if(typeof input == 'number') {
		return input
	}

	return null;
}

module.exports = {
	format,
	valueOf
}